<template>
  <router-view></router-view>
</template>

<script>
import useDebug from '@/composables/use-debug';

export default {
  name: 'App',
  setup() {
    useDebug()
    return {};
  },
};
</script>
